function parseCategoryClassId(group) {
  if (group == null) return null;
  return `class-id-group-${group.id}`;
}

export { parseCategoryClassId };
